import { render, staticRenderFns } from "./BusInfoShopDataRecordsModal__Style#Drawer.vue?vue&type=template&id=70853854&scoped=true&"
import script from "./BusInfoShopDataRecordsModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BusInfoShopDataRecordsModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BusInfoShopDataRecordsModal__Style#Drawer.vue?vue&type=style&index=0&id=70853854&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70853854",
  null
  
)

export default component.exports